module.exports = __webpack_public_path__ + "img/menuboard_thai_express.5f077a6b.webp";